import axios from "axios";
const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;

export const getCollectionAndProductsByRosterId = (rosterId, user) => {
  let headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + user.stsTokenManager.accessToken,
  };

  return axios.get(
    BALLPARK_BACKEND_BASE_URL +
      "allProductsAndCollectionsByRosterId?id=" +
      rosterId,
    {
      headers,
    }
  );
};
